import memoize from 'memoize-one';

import { accountRoutes } from './account';
import { globalRoutes } from './global';
import { projectRoutes } from './project';
import { repositoryRoutes } from './repository';
import { Routes, RouteFeatures } from './types';
import { workspaceRoutes } from './workspace';

export const getRoutes = memoize((features: RouteFeatures): Routes => {
  return [
    ...globalRoutes(),
    ...accountRoutes,
    ...workspaceRoutes(features),
    ...projectRoutes(features),
    ...repositoryRoutes(features),
  ];
});
